module.exports = __webpack_public_path__ + "static/media/preview.144daed3.png";